import * as projection from "@arcgis/core/geometry/projection";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as geometryJsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import FieldNames from "../defaults/FieldNames.json";
import { getSaveableDate } from "../utils/DateHelper";
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from "../utils/ReduxHelper";
import Request from "./request";
import Query from "@arcgis/core/rest/support/Query";
import * as query from "@arcgis/core/rest/query";
import GeneralService from "./GeneralService";
import {getServiceLayerId} from "../utils/UploadHelper";

const GeometryService = {
  addGeometry: function (perimeterJSON, geometryType, nifcUserName) {
    const attributes = {
      LastModifiedBy: nifcUserName,
      CreatedBy: nifcUserName,
      LastModifiedDate: getSaveableDate(new Date()),
      CreatedOnDate: getSaveableDate(new Date())
    }

    return this.geometryRequest(perimeterJSON, geometryType, attributes, false)
  },
  updateGeometry: function (perimeterJSON, geometryType, nifcUserName, objectID) {
    const attributes = {
      OBJECTID: objectID,
      LastModifiedBy: nifcUserName,
      LastModifiedDate: getSaveableDate(new Date()),
    }

    return this.geometryRequest(perimeterJSON, geometryType, attributes, true)
  },
  geometryRequest: function (perimeterJSON, geometryType, attributes, isUpdate) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const nifcToken = getNifcToken();
      let geoLayerID = getServiceLayerId(geometryType, config);
      const actionType = isUpdate ? 'updateFeatures' : 'addFeatures';
      let featureUrl = `${rootServiceUrl}/${geoLayerID}/${actionType}`;

      return new Promise((resolve, reject) => {
        projection.load().then(function () {
          if (perimeterJSON) {
            const perimeter = geometryJsonUtils.fromJSON(perimeterJSON);
            const nad83geometry = projection.project(perimeter, new SpatialReference({wkid: 4269}));

            const feature =
            {
                geometry: nad83geometry.toJSON(),
                attributes: attributes
            };

            new Request().makeRequest({
                url: featureUrl,
                method: 'post',
                data: {
                    f: 'json',
                    token: nifcToken,
                    features: JSON.stringify([feature])
                }
            }).then(
                resp => {
                    resolve(resp)
                },
                error => {
                  reject(error)
                }
            );
          } else {
            throw Error("Perimeter JSON is invalid")
          }
        });
      });
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
  getGeometryByIDType: function (
    geometryID,
    geometryType
  ) {
    try
    {
      const config = getAppConfig();
      const rootServiceUrl = getAttributeServiceUrl();
      const geoLayerID = getServiceLayerId(geometryType, config);
      let geometryUrl = `${rootServiceUrl}/${geoLayerID}`;
      const queryObject = new Query({
        where: "(ID = " + geometryID + ")",
        outFields: "ID, OBJECTID",
        returnGeometry: true,
      });
      return GeneralService.queryCallSingle(geometryUrl, queryObject);
    }
    catch(e)
    {
      return new Promise((resolve,reject) => {
        reject(e);
      });
    }
  },
};

export default GeometryService;
